var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UndoIcon from '@mui/icons-material/Undo';
import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { FuncionarioModalForm } from '../../../components/Funcionario/FuncionarioModalForm';
import { FilterComponent } from '../../../components/Pagination/FilterComponent';
import { ListProvider, useList, } from '../../../components/Pagination/ListContext';
import { OrderComponent } from '../../../components/Pagination/OrderComponent';
import { PaginationComponent } from '../../../components/Pagination/PaginationComponent';
import { RenderList } from '../../../components/Pagination/RenderList';
import { useWizard } from '../../../components/Wizard/useWizard';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { getByFuncionarioProcessoId, searchFuncionarioEdicao, removeFuncionarioEdicaoInProcesso, revertFuncionarioExclusion, } from '../../../services/processo-funcionario-edicao.service';
import { formatCpf } from '../../../util/masks';
import { useProcessEdicaoContext } from '../context/ProcessEdicaoContext';
import { RequestLoadingIndicator } from '../../../components/RequestLoadingIndicator';
import { StatusEdicaoTag } from '../../../components/StatusEdicaoTag';
import { useDialog } from '../../../hooks/useDialog';
import { StatusEdicaoEnum } from '../../../enums/status-edicao.enum';
import { GrupoCampoAnalise, StatusItemAnalise, } from '../../../enums/analise.enum';
var filterFields = [
    { label: 'Nome', name: 'nome', type: 'text' },
    { label: 'CPF', name: 'cpf', type: 'text' },
];
export var FuncionariosForm = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useWizard(), nextStep = _c.nextStep, prevStep = _c.prevStep;
    var processo = useProcessEdicaoContext().processo;
    var handleSearchItems = function (filters, params) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId)) {
                        return [2 /*return*/, Promise.resolve({
                                page: 1,
                                pageSize: 10,
                                total: 0,
                                items: [],
                            })];
                    }
                    return [4 /*yield*/, searchFuncionarioEdicao(processo.processoEdicaoId, filters, params)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    if (!(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId)) {
        return _jsx(RequestLoadingIndicator, { loading: true });
    }
    return (_jsx(ListProvider, { fetchItems: handleSearchItems, filterFields: filterFields, children: _jsx(FuncionariosListContent, { disabled: disabled, nextStep: nextStep, prevStep: prevStep }) }));
};
var FuncionariosListContent = function (_a) {
    var disabled = _a.disabled, nextStep = _a.nextStep;
    var refresh = useList().refresh;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var navigate = useNavigate();
    var confirm = useDialog().confirm;
    var _c = useProcessEdicaoContext(), servico = _c.servico, processo = _c.processo, analise = _c.analise, addFuncionario = _c.addFuncionario, updateFuncionario = _c.updateFuncionario;
    var getStatus = function (funcionario) {
        var _a;
        if (!analise) {
            return null;
        }
        var gruposCampos = [
            GrupoCampoAnalise.DADOS_GERAIS,
            GrupoCampoAnalise.CONTATO,
            GrupoCampoAnalise.ENDERECO,
        ];
        var statusGrupos = (_a = analise === null || analise === void 0 ? void 0 : analise.gruposCampos) === null || _a === void 0 ? void 0 : _a.filter(function (g) {
            return g.entidade === 'FUNCIONARIO' &&
                g.entidadeAssociadaId === funcionario.id &&
                gruposCampos.every(function (gc) { return gc === g.grupo; });
        });
        if (statusGrupos && statusGrupos.length === 3) {
            if (statusGrupos.some(function (sg) { return sg.status === StatusItemAnalise.REPROVADO; })) {
                return { status: 'error', message: 'Reprovado' };
            }
            else if (statusGrupos.every(function (sg) { return sg.status === StatusItemAnalise.APROVADO; })) {
                return { status: 'success', message: 'Aprovado' };
            }
        }
        return { status: 'info', message: 'Aguardando análise' };
    };
    var _d = useState(null), modalFuncionarioOpen = _d[0], setModalFuncionarioOpen = _d[1];
    var _e = useState(undefined), selectedFuncionario = _e[0], setSelectedFuncionario = _e[1];
    var handleOpenAddFuncionario = function () {
        setModalFuncionarioOpen('adicionar');
        setSelectedFuncionario(undefined);
    };
    var handleGetFuncionario = function (funcionarioId, modo) {
        setLoading(true);
        getByFuncionarioProcessoId(processo.processoEdicaoId, funcionarioId)
            .then(function (funcionario) {
            setSelectedFuncionario(funcionario);
            setModalFuncionarioOpen(modo);
        })
            .finally(function () { return setLoading(false); });
    };
    var handleOpenEditFuncionario = function (funcionario, event) {
        event.preventDefault();
        handleGetFuncionario(funcionario.id, 'editar');
    };
    var handleOpenViewFuncionario = function (funcionario, event) {
        event.preventDefault();
        handleGetFuncionario(funcionario.id, 'visualizar');
    };
    var handleCloseModal = function () {
        setModalFuncionarioOpen(null);
        setSelectedFuncionario(undefined);
    };
    var handleSaveFuncionario = function (funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 5, 6]);
                    setLoading(true);
                    if (!selectedFuncionario) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateFuncionario(selectedFuncionario.id, funcionario)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addFuncionario(funcionario)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    refresh();
                    return [3 /*break*/, 6];
                case 5:
                    setModalFuncionarioOpen(null);
                    setSelectedFuncionario(undefined);
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteFuncionario = function (funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, confirm({
                        title: 'Confirmar Exclusão',
                        content: "Tem certeza que deseja excluir o funcion\u00E1rio \"".concat(funcionario.nome, "\"?"),
                        confirmationText: 'Excluir',
                        cancellationText: 'Cancelar',
                    })];
                case 1:
                    confirmed = _b.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, 5, 6]);
                    setLoading(true);
                    return [4 /*yield*/, removeFuncionarioEdicaoInProcesso(processo.processoEdicaoId, funcionario.id)];
                case 3:
                    _b.sent();
                    enqueueSnackbar('Funcionário excluído com sucesso!', {
                        variant: 'success',
                    });
                    refresh();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    enqueueSnackbar('Erro ao excluir funcionário. Tente novamente.', {
                        variant: 'error',
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleRevertExclusion = function (funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, confirm({
                        title: 'Reverter Exclusão',
                        content: "Tem certeza que deseja reverter a exclus\u00E3o do funcion\u00E1rio \"".concat(funcionario.nome, "\"?"),
                        confirmationText: 'Reverter',
                        cancellationText: 'Cancelar',
                    })];
                case 1:
                    confirmed = _b.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, 5, 6]);
                    setLoading(true);
                    return [4 /*yield*/, revertFuncionarioExclusion(processo.processoEdicaoId, funcionario.id)];
                case 3:
                    _b.sent();
                    enqueueSnackbar('Exclusão revertida com sucesso!', {
                        variant: 'success',
                    });
                    refresh();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    enqueueSnackbar('Erro ao reverter exclusão. Tente novamente.', {
                        variant: 'error',
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handlePrevStep = function () {
        navigate(-1);
    };
    var isFormEnabled = !!(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId) && !disabled;
    return (_jsxs(Box, { children: [_jsx(RequestLoadingIndicator, { loading: loading }), _jsxs(Box, { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", mb: 1, children: [_jsxs(Box, { children: [_jsx(OrderComponent, { color: "primary" }), _jsx(FilterComponent, { color: "primary" })] }), _jsx(Box, { sx: { display: 'flex', alignItems: 'center' }, children: isFormEnabled && (_jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(AddIcon, {}), onClick: handleOpenAddFuncionario, children: "Adicionar Funcion\u00E1rio(a)" })) })] }), _jsx(RenderList, { titleField: function (funcionario) { return "".concat(funcionario.nome); }, getStatus: getStatus, renderItem: function (funcionario) { return (_jsxs(_Fragment, { children: [_jsx(Box, { children: _jsxs(Typography, { variant: "body2", children: ["CPF: ", formatCpf(funcionario.cpf)] }) }), _jsxs(Typography, { variant: "body2", children: ["Telefone: ", funcionario.telefone] }), _jsxs(Typography, { variant: "body2", children: ["Email: ", funcionario.email] }), funcionario.status && (_jsx(Box, { sx: { mt: 1, mb: 1 }, children: _jsx(StatusEdicaoTag, { status: funcionario.status, size: "small" }) }))] })); }, actionButtons: [
                    {
                        icon: _jsx(EditIcon, {}),
                        color: 'primary',
                        onClick: handleOpenEditFuncionario,
                        tooltip: 'Editar',
                        visible: function (funcionario) {
                            return isFormEnabled && funcionario.status !== StatusEdicaoEnum.EXCLUIDO;
                        },
                    },
                    {
                        icon: _jsx(VisibilityIcon, {}),
                        color: 'primary',
                        onClick: handleOpenViewFuncionario,
                        tooltip: 'Visualizar',
                    },
                    {
                        icon: _jsx(DeleteIcon, {}),
                        color: 'error',
                        onClick: handleDeleteFuncionario,
                        tooltip: 'Excluir',
                        visible: function (funcionario) {
                            return isFormEnabled && funcionario.status !== StatusEdicaoEnum.EXCLUIDO;
                        },
                    },
                    {
                        icon: _jsx(UndoIcon, {}),
                        color: 'primary',
                        onClick: handleRevertExclusion,
                        tooltip: 'Reverter Exclusão',
                        visible: function (funcionario) {
                            return isFormEnabled && funcionario.status === StatusEdicaoEnum.EXCLUIDO;
                        },
                    },
                ] }), _jsx(PaginationComponent, {}), _jsx(WizardButtons, { nextClick: nextStep, prevClick: handlePrevStep }), !!modalFuncionarioOpen && (_jsx(FuncionarioModalForm, { modo: modalFuncionarioOpen, open: true, funcionario: selectedFuncionario, servico: servico, analise: analise, onClose: handleCloseModal, onSave: handleSaveFuncionario }))] }));
};
